import Vue from "vue";
import Vuex from "vuex";

import auth from "./auth.module";
import commercialLocation from "./commercialLocation";
import commercialLocations from "./commercialLocations";
import commercialClient from "./commercialClient";
import organizationSettings from "./organizationSettings";
import timeAndDate from "./timeAndDate";
import commercialSchedules from "./commercialSchedules";
import residentialSchedules from "./residentialSchedules";
import residentialClientContacts from "./residentialClientContacts";
import residentialClientLocation from "./residentialClientLocation";
import dashboardCharts from "./dashboardCharts";
import tableData from "./tableData";
import emiter from "./emiter";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    auth,
    commercialLocations,
    commercialLocation,
    commercialClient,
    organizationSettings,
    timeAndDate,
    commercialSchedules,
    residentialSchedules,
    residentialClientContacts,
    residentialClientLocation,
    dashboardCharts,
    tableData,
    emiter
  },
  state: {
    active_tab_client_onboarding: 0,
    active_tab_pricing_setup: 0
  },
  mutations: {},
  actions: {}
});
